import React from 'react'
import PropTypes from 'prop-types'
import { Controller } from 'react-hook-form'
import {
  FormControl,
  FormHelperText,
  FormLabel,
  MenuItem,
  Select as MuiSelect,
  OutlinedInput,
} from '@mui/material'
import { inputSizes } from '../../constants/input'

const Select = ({ options, name, control, errors, size, placeholder, label, sx, sxFC, sxFL }) => {
  return (
    <Controller
      name={name}
      defaultValue={''}
      control={control}
      render={({ field }) => (
        <FormControl fullWidth sx={{ mb: 1, ...sxFC }}>
          <FormLabel htmlFor={name}>{label}</FormLabel>
          <MuiSelect
            {...field}
            displayEmpty
            size={size}
            sx={{ color: !field.value ? 'rgba(0,0,0,.5)' : 'black', ...sx }}
            onChange={(e) => field.onChange(e.target.value)}
            input={<OutlinedInput error={!!errors[name]} />}
          >
            <MenuItem value="" disabled>
              {placeholder}
            </MenuItem>
            {options.map((option, idx) => (
              <MenuItem key={idx} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </MuiSelect>
          {!!errors[name] && (
            <FormHelperText error={!!errors[name]}>
              {errors[name] && errors[name].message}
            </FormHelperText>
          )}
        </FormControl>
      )}
    />
  )
}
Select.defaultProps = {
  size: 'large',
  label: 'Select Label',
  placeholder: 'Select one',
}

Select.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
    }),
  ),
  name: PropTypes.string.isRequired,
  errors: PropTypes.any.isRequired,
  label: PropTypes.string,
  size: PropTypes.oneOf(inputSizes),

  placeholder: PropTypes.string,
}

export default Select
